export const en = {
    logout: `Logout`,
    changePassword: `Change Password`,
    editProfile: `Edit Profile`,
    theme: `Theme`,
    language: `Language`,
};
//# sourceMappingURL=en.js.map